import { ImgFlagsAllowed, LanguageSelectorList } from '@foxeet/domain';
import { enLang, esLang, ptLang } from '../assets/i18n';

export const AVAILABLE_LANGUAGES: LanguageSelectorList = [
  {
    lang: enLang.languageKey,
    label: 'english',
    img: ImgFlagsAllowed.UK,
    cultureCodeLanguage: 'en-GB'
  },
  {
    lang: esLang.languageKey,
    label: 'spanish',
    img: ImgFlagsAllowed.SPAIN,
    cultureCodeLanguage: 'es-ES'
  },
  {
    lang: ptLang.languageKey,
    label: 'portuguese',
    img: ImgFlagsAllowed.PORTUGAL,
    cultureCodeLanguage: 'pt-PT'
  },
];
